<div class="gpd-config-section">
  <div>
    <div class="sandbox-title-row">
      <span class="gpd-config-section-title">Sandbox</span>
      <div class="help-wrapper">
        <app-svg-icon icon="help" [size]="16" class="help-icon"></app-svg-icon>
        <span class="help-tooltip">{{ helpTooltip }}</span>
      </div>
    </div>
    <p class="gpd-config-section-description">{{ sandboxDescription }}</p>
  </div>

  <dx-radio-group
    [items]="structureModeOptions"
    [(value)]="structureMode"
    valueExpr="value"
    displayExpr="label"
    (onValueChanged)="onStructureModeChanged($event)"
  ></dx-radio-group>

  <app-folder-tree-config
    *ngIf="structureMode === 'custom'"
    [treeTypeInput]="context === 'site' ? 'sandbox-site' : 'sandbox-project'"
    [showHeader]="false"
  ></app-folder-tree-config>
</div>
